import { getLookupList, callUIAPI, searchEntityRecords } from "../utils/apiUtils"
import { 
  ENTITY_NAME_BACK_OFFICE_BILLING_METRICS,
  ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_FIRM_NAME,
  ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_USER_NAME,
  ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_OPERATION, 
  ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_SCREEN
} from "./dbConstants"
import { METHOD_POST } from '../utils/apiUtilsConstants'

export const getFirmNameListOptions = async() => {
  return getLookupList(ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_FIRM_NAME);
}

export const getUserNameListOptions = async(firmId) => {
  return getLookupList(ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_USER_NAME, {firmId});
}

export const getScreenListOptions = async() => {
  return getLookupList(ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_SCREEN);
}

export const getOperationListOptions = async() => {
  return getLookupList(ENTITY_NAME_BACK_OFFICE_BILLING_METRICS_OPERATION);
}

export const getUsageSummary = async (filters) => {
  const response = await callUIAPI('bo/billing/summary', filters, METHOD_POST, true);
  return response.data;
}

export const searchUsage = async (params) => {
  const response = await searchEntityRecords(ENTITY_NAME_BACK_OFFICE_BILLING_METRICS, params);
  return response.data;
}
